// extracted by mini-css-extract-plugin
export var button = "_al-7";
export var buttonRow = "_al-6";
export var fadeIn = "_al-1";
export var gradient = "_al-0";
export var panel = "_al-2";
export var panelIn = "_al-3";
export var subtitle = "_al-5";
export var title = "_al-4";